module.exports = __webpack_public_path__ + "static/media/ds-podium.84c7829d.png";